export default "__VITE_ASSET__BvVwd6G2__"